import { DefaultService } from '@/services/DefaultService';

/* @71156 */
export default class AgroVisitaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    findAll(filtro, column, order, page = 0, limit = 20, ...params) {
      return this._http.post(encodeURI(`${this._env}/agro/visita.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), filtro, this._headers).then(res => {
        return res.body;
      }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
      });
    }

    find(id) {
      return this._http.get(`${this._env}/agro/visita/${id}.json`, this._headers).then(res => {
        return res.body;
      }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
      });
    }

    findByUuid(uuid) {
      return this._http.get(`${this._env}/agro/visita/uuid/${uuid}.json`, this._headers).then(res => {
        return res.body;
      }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
      });
    }
    
    save(lista) {
      return this._http.post(`${this._env}/agro/visita`, lista, this._headers).then(res => {
        return res.body;
      }, err => {
        this.verifyError(err);
        throw err;
      });
    }
    delete(visita) {
      // console.log(visita);
    }
}